var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62787 13.8801H0.510986V0.581421H5.57592C6.94389 0.581421 8.12571 0.847655 9.12138 1.38012C10.1214 1.90826 10.8919 2.67017 11.4331 3.66584C11.9785 4.65718 12.2512 5.84549 12.2512 7.23077C12.2512 8.61605 11.9807 9.80653 11.4396 10.8022C10.8984 11.7935 10.1322 12.5554 9.14086 13.0879C8.14951 13.6161 6.97852 13.8801 5.62787 13.8801ZM4.12138 10.8152H5.498C6.15601 10.8152 6.71661 10.7091 7.17982 10.497C7.64735 10.2849 8.00233 9.91908 8.24475 9.3996C8.49151 8.88012 8.61488 8.15718 8.61488 7.23077C8.61488 6.30437 8.48934 5.58142 8.23826 5.06194C7.99151 4.54246 7.62787 4.17666 7.14735 3.96454C6.67116 3.75242 6.08674 3.64636 5.3941 3.64636H4.12138V10.8152Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.395f9ce0f1afcc76384e3c1f9a04d8f4.svg";
export { ForwardRef as ReactComponent };